import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/EditMyCompanyMemberEmploymentDaysGroupWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  convertHoursToMinutes,
  convertMinutesToHours,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import * as _ from 'lodash';
import EditDataIcon from '../assets/images/edit-specification-code-64x64.svg';
import {
  readCompanyMember,
  updateCompanyMemberEmploymentTermsDaysData,
} from '../redux/actions/table/my_company_members';
import EditMyCompanyMemberEmploymentDaysGroupForm from '../forms/edit_my_company_member_employment_days_group_wizard/EditMyCompanyMemberEmploymentDaysGroupForm';
import EditMyCompanyMemberEmploymentDaysFutureGroupForm from '../forms/edit_my_company_member_employment_days_group_wizard/EditMyCompanyMemberEmploymentDaysFutureGroupForm.js';

@mapStateToProps((state) => ({
  store: _.get(state.table, 'my_company_members'),
}))
@withRouter
class EditMyCompanyMemberEmploymentDaysGroupWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: '01',
      steps: [
        {
          id: '01',
          title: __('wizard.my-company-members.title.week-days-current-group'),
        },
        {
          id: '02',
          title: __('wizard.my-company-members.title.week-days-future-group'),
        },
      ],
    };
  }
  @autobind
  _setActiveStep(id) {
    this.setState({ active: id });
  }
  @autobind
  _handleSubmitCurrent(formData) {
    const { store } = this.props;

    let data = {
      ...formData,
      user_id: store.flyout.details.id,
      monday_minutes: convertHoursToMinutes(formData?.monday_minutes),
      tuesday_minutes: convertHoursToMinutes(formData?.tuesday_minutes),
      wednesday_minutes: convertHoursToMinutes(formData?.wednesday_minutes),
      thursday_minutes: convertHoursToMinutes(formData?.thursday_minutes),
      friday_minutes: convertHoursToMinutes(formData?.friday_minutes),
      saturday_minutes: convertHoursToMinutes(formData?.saturday_minutes),
      sunday_minutes: convertHoursToMinutes(formData?.sunday_minutes),
    };

    return validateForm(
      updateCompanyMemberEmploymentTermsDaysData(data).then(() => {
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __(
                'my-company-members.employment-terms.current-days-group.updated'
              )
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  @autobind
  _handleSubmitFuture(formData) {
    const { store } = this.props;

    let data = {
      ...formData,
      user_id: store.flyout.details.id,
      is_new: true,
      monday_minutes: convertHoursToMinutes(formData?.monday_minutes),
      tuesday_minutes: convertHoursToMinutes(formData?.tuesday_minutes),
      wednesday_minutes: convertHoursToMinutes(formData?.wednesday_minutes),
      thursday_minutes: convertHoursToMinutes(formData?.thursday_minutes),
      friday_minutes: convertHoursToMinutes(formData?.friday_minutes),
      saturday_minutes: convertHoursToMinutes(formData?.saturday_minutes),
      sunday_minutes: convertHoursToMinutes(formData?.sunday_minutes),
    };

    return validateForm(
      updateCompanyMemberEmploymentTermsDaysData(data).then(() => {
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __(
                'my-company-members.employment-terms.future-days-group.updated'
              )
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  render() {
    const { employmentDaysData } = this.props.store;

    const { steps, active } = this.state;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.title}>
            <div className={styles.left}>
              <span>
                {__(
                  'wizard.my-company-members.title.edit-my-company-member-employment-days-group'
                )}
              </span>
              <span>
                {__(
                  'wizard.my-company-members.subtitle.edit-my-company-member-employment-days-group'
                )}
              </span>
            </div>
            <div className={styles.right}>
              <EditDataIcon />
            </div>
          </div>
          <div className={styles.steps}>
            {_.map(steps, (step, i) => (
              <div
                key={i}
                onClick={() => this._setActiveStep(step.id)}
                className={`
                ${styles.step} 
                ${active === step.id ? styles.active : ''}
              `}
              >
                <span>{step.id}</span>
                <span>{step.title}</span>
              </div>
            ))}
          </div>{' '}
        </div>

        {/* TAB CONTENT */}
        <div className={styles.body}>
          {active === '01' && (
            <EditMyCompanyMemberEmploymentDaysGroupForm
              onSubmit={this._handleSubmitCurrent}
              initialValues={{
                monday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.current?.monday_minutes
                  ) || null,
                tuesday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.current?.tuesday_minutes
                  ) || null,
                wednesday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.current?.wednesday_minutes
                  ) || null,
                thursday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.current?.thursday_minutes
                  ) || null,
                friday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.current?.friday_minutes
                  ) || null,
                saturday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.current?.saturday_minutes
                  ) || null,
                sunday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.current?.sunday_minutes
                  ) || null,
                hours_start_date:
                  employmentDaysData?.current?.hours_start_date || null,
                hours_end_date:
                  employmentDaysData?.current?.hours_end_date || null,
              }}
            />
          )}

          {active === '02' && (
            <EditMyCompanyMemberEmploymentDaysFutureGroupForm
              onSubmit={this._handleSubmitFuture}
              initialValues={{
                monday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.future?.monday_minutes
                  ) || null,
                tuesday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.future?.tuesday_minutes
                  ) || null,
                wednesday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.future?.wednesday_minutes
                  ) || null,
                thursday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.future?.thursday_minutes
                  ) || null,
                friday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.future?.friday_minutes
                  ) || null,
                saturday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.future?.saturday_minutes
                  ) || null,
                sunday_minutes:
                  convertMinutesToHours(
                    employmentDaysData?.future?.sunday_minutes
                  ) || null,
                hours_start_date:
                  employmentDaysData?.future?.hours_start_date || null,
                hours_end_date:
                  employmentDaysData?.future?.hours_end_date || null,
              }}
            />
          )}
        </div>
      </>
    );
  }
}

export default EditMyCompanyMemberEmploymentDaysGroupWizard;
